
// @ts-ignore
import {IMaskComponent} from 'vue-imask';
import Socials from '../../components/socials.vue';
import {authApi} from '../../src/Api';
import YiiCaptcha from '../../components/yii-captcha.vue';
import {SendCodePageSetting} from '../../src/Event/SendCodePageSetting';
import {defineComponent, PropType} from 'vue';
import AuthModel from '../../src/Model';
import {AuthAppService} from '../../src/AuthAppService';
import YandexCaptcha from "modules/auth/components/yandex-captcha.vue";
import Captcha from "modules/auth/components/captcha.vue";

export default defineComponent({
    components: {
        Captcha,
        YandexCaptcha,
        YiiCaptcha,
        Socials,
        'imask-input': IMaskComponent,
    },
    props: {
        service: {
            type: Object as PropType<AuthAppService>,
            required: true,
        },
        modelValue: {
            type: Object as PropType<AuthModel>,
            required: true,
        },
    },
    emits: ['next'],
    data() {
        let defaultTab = 'phone';
        if (!this.service.configuration.isPhone) {
            defaultTab = 'email';
        }

        return {
            type: defaultTab,
            clientName: this.service.configuration.clientName,
            clientDescription: this.service.configuration.clientDescription,
            phone: null,
            email: null,
            loading: false,
            inputError: null,
            verifyCode: null,
            captchaError: null,
            error: null,
        };
    },
    computed: {
        configuration() {
            return this.service.configuration;
        },

    },
    watch: {
        phone: function() {
            this.inputError = false;
        },
        email: function() {
            this.inputError = false;
        },
    },
    mounted() {
        this.error = this.service.configuration.errorMessage;
    },
    methods: {
        async onNext() {
            this.loading = true;
            try {
                await this.$refs.captcha.execution();
            } catch (errorMessage) {
                this.error = errorMessage;
                this.loading = false;
                return;
            }


            try {
                const value = this.type === 'phone' ? this.phone : this.email;
                const result = await authApi.auth(value, this.type, this.verifyCode);
                if (result.error()) {
                    this.inputError = result.error().message;
                    this.captchaError = result.error().captchaMessage;
                } else {
                    const resp = result.response();
                    this.modelValue.phone = this.phone;
                    this.modelValue.email = this.email;
                    this.modelValue.sendCodePageSetting = new SendCodePageSetting(resp.sendCodeText, resp.ttl, resp.hash);
                    this.modelValue.hash = resp.hash;

                    this.$emit('next', this.modelValue);
                }
            } catch (err) {
                this.error = err.response.data.message;
            } finally {
                this.$refs.captcha.refresh();
                this.loading = false;
            }
        },
        clear() {
            this.inputError = null;
            this.captchaError = null;
            this.error = null;
        },
        showOAuth() {
            if (!this.configuration.isPhone && !this.configuration.isEmail) {
                return false;
            }

            return this.configuration.isEsia || this.configuration.isSocials;
        },
        onChangePhone() {
            this.clear();
        },
    },
});
